module.exports = __webpack_public_path__ + "static/media/futbol.0b1843e8.svg";